// Navigation/Footer.js
import React from "react";
import { FaReact } from "react-icons/fa";
import { SiNextdotjs, SiTailwindcss } from "react-icons/si";

const Footer = () => (
  <footer className="app-footer mt-12 border-t border-slate-200 bg-[#f8fafc] transition-colors duration-300 dark:border-slate-800 dark:bg-slate-950">
    <div className="max-w-5xl mx-auto px-4 py-6 flex flex-col md:flex-row items-center justify-between text-gray-600 text-sm dark:text-slate-300">
      <p>Made by Siddhant Kumar with React, Next.js &amp; Tailwind CSS</p>
      <div className="flex space-x-4 mt-4 md:mt-0">
        <FaReact
          size={24}
          title="React"
          className="text-gray-500 transition hover:text-orange-500 dark:text-slate-400 dark:hover:text-[#F59E0B]"
        />
        <SiNextdotjs
          size={24}
          title="Next.js"
          className="text-gray-500 transition hover:text-orange-500 dark:text-slate-400 dark:hover:text-[#F59E0B]"
        />
        <SiTailwindcss
          size={24}
          title="Tailwind CSS"
          className="text-gray-500 transition hover:text-orange-500 dark:text-slate-400 dark:hover:text-[#F59E0B]"
        />
      </div>
    </div>
  </footer>
);

export default Footer;
